import React from 'react'

function Header() {
    return (
        <div className="flex justify-center w-full max-w-[400px] h-[58px] items-center px-4 py-0 mb-[16px]">
          <img src="/assets/img/Footer logo.png" alt="digitmoney logo" className="h-[24px] w-auto]" />
          
        </div>
    )
}

export default Header